import { TranslatePipe } from "@ngx-translate/core";
import { AngularSvgIconModule } from "angular-svg-icon";

import { ChangeDetectionStrategy, Component, computed, model } from "@angular/core";
import { input } from "@angular/core";

import { EmptyState } from "../empty-state/empty-state";
import { TabbedDetailNavigation } from "./components/tabbed-detail-navigation/tabbed-detail-navigation";

@Component({
  selector: "tabbed-detail-base",
  templateUrl: "tabbed-detail-base.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [AngularSvgIconModule, EmptyState, TabbedDetailNavigation, TranslatePipe],
})
export class TabbedDetailBase {
  protected tabs = input.required<{ title: string; subtitle: string }[]>();
  protected activeTabIndex = model(0);

  protected hasServices = computed(() => this.tabs().length > 0);
}
